<template>
    <div class="clientArea secPdng animated">
        <div class="container">
            <!--<div class="row">-->
            <!--<div class="col-md-12">-->
            <!--<div class="sectionTitle">-->
            <!--<div class="h2">Os nossos <span>parceiros</span><br> de negócio.</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <div class="row">
                <div class="col-md-3 col-sm-4 col-xs-6" v-for="(partner, index) in partners" :key="index">
                    <div class="singleClient">
                        <a :href="partner.url" target="_blank">
                            <img :src="partner.image_url" alt=""/>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Partners from '@/database/partners.json'

  export default {
    name: 'site-partners',
    data() {
      return {
        partners: Partners
      }
    }
  }
</script>

<style scoped>
    .clientArea {
        background: #f0f5fa;
    }
</style>



// WEBPACK FOOTER //
// src/components/site/SitePartners.vue